<template>
  <v-container fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex sm6 xs12 md6 lg4>
        <material-stats-card
          color="green"
          icon="mdi-speedometer"
          title="Registered Meters"
          :value="devices_counter"
          sub-text=""
        />
      </v-flex>
      <v-flex sm6 xs12 md6 lg4>
        <material-stats-card
          color="orange"
          icon="mdi-link-off"
          title="Unmatched Meters"
          :value="orphans_counter"
          sub-text=""
        />
      </v-flex>
      <v-flex sm6 xs12 md6 lg4>
        <material-stats-card
          color="info"
          icon="mdi-file-document"
          title="Projects"
          :value="projects_counter"
          sub-text=""
        />
      </v-flex>
      <v-flex sm6 xs12 md6 lg4>
        <material-stats-card
          color="green"
          icon="mdi-account"
          title="Registered Users"
          :value="users_counter"
          sub-text=""
        />
      </v-flex>
      <v-flex sm6 xs12 md6 lg4>
        <material-stats-card
          color="orange"
          icon="mdi-link-off"
          title="Unmatched Users"
          :value="unmatched_counter"
          sub-text=""
        />
      </v-flex>
      <v-flex sm6 xs12 md6 lg4>
        <material-stats-card
          color="red"
          icon="mdi-account-remove"
          title="Unapproved Users"
          :value="unapproved_counter"
          sub-text=""
        />
      </v-flex>
      <v-flex md12>
        <div>
          <material-card color="primary" title="Unapproved Users">
            <v-spacer />
            <v-text-field
              v-model="searchUnapproved"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            />
            <v-dialog v-model="dialogDelete" max-width="500px">
              <v-card>
                <v-card-title class="headline"
                  >Are you sure you want to delete this user?</v-card-title
                >
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="closeDelete"
                    >Cancel</v-btn
                  >
                  <v-btn color="green darken-1" text @click="deleteItemConfirm"
                    >OK</v-btn
                  >
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialogApprove" max-width="500px">
              <v-card>
                <v-card-title class="headline"
                  >Are you sure you want to approve this user?</v-card-title
                >
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="closeApprove"
                    >Cancel</v-btn
                  >
                  <v-btn color="green darken-1" text @click="approveItemConfirm"
                    >OK</v-btn
                  >
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-data-table
              :headers="headersUnapproved"
              :items="UnapprovedUsersList"
              :search="searchUnapproved"
              class="unapproved-users-table"
              hide-actions
            >
              <!-- change table header background and text color(or other properties) -->
              <template slot="headerCell" slot-scope="{ header }">
                <span
                  class="subheading font-weight-light text-general text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template v-slot:items="props">
                <td class="">
                  {{
                    props.item.firstname !== null && props.item.firstname !== ""
                      ? props.item.firstname
                      : "-"
                  }}
                </td>
                <td class="">
                  {{
                    props.item.lastname !== null && props.item.lastname !== ""
                      ? props.item.lastname
                      : "-"
                  }}
                </td>
                <td class="">
                  {{
                    props.item.email !== null && props.item.email !== ""
                      ? props.item.email
                      : "-"
                  }}
                </td>
                <td class="">
                  {{
                    props.item.address !== null && props.item.address !== ""
                      ? props.item.address
                      : "-"
                  }}
                </td>
                <!-- <td class="">
                  {{
                    props.item.supply_number !== null &&
                    props.item.supply_number !== ""
                      ? props.item.supply_number
                      : "-"
                  }}
                </td>
                <td class="">
                  {{
                    props.item.kwh_price !== null && props.item.kwh_price !== ""
                      ? props.item.kwh_price
                      : "-"
                  }}
                </td> -->
                <td class="justify-center ">
                  <v-icon medium @click="approveItem(props.item)"
                    >mdi-account-check</v-icon
                  >
                  <v-icon medium @click="deleteItem(props.item)">delete</v-icon>
                </td>
              </template>
            </v-data-table>
            <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
              {{ snackText }}
              <v-btn flat @click="snack = false">Close</v-btn>
            </v-snackbar>
          </material-card>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    snack: false,
    snackColor: "",
    snackText: "",
    UnapprovedUsersList: [],
    rowsAmount: [
      10,
      15,
      20,
      { text: "$vuetify.dataIterator.rowsPerPageAll", value: -1 },
    ],
    dialogDelete: false,
    dialogApprove: false,
    search: "",
    searchUnapproved: "",
    headersUnapproved: [
      { text: "Id", value: "id", align: " d-none" },
      { text: "First Name", value: "firstname" },
      { text: "Last Name", value: "lastname" },
      { text: "Email", value: "email" },
      { text: "Address", value: "address" },
      // { text: "Supply Number", value: "supply_number" },
      // { text: "kWh Price", value: "kwh_price" },
      { text: "Actions", value: "actions", sortable: false },
    ],
    approvedIndex: -1,
    approvedItem: {},
    deletedIndex: -1,
    deletedItem: {},
    defaultItem: {},
    users_counter: "",
    devices_counter: "",
    projects_counter: "",
    orphans_counter: "",
    unmatched_counter: "",
    unapproved_counter: "",
  }),

  watch: {
    dialogDelete(val) {
      val || this.closeDelete();
    },
    dialogApprove(val) {
      val || this.closeApprove();
    },
  },
  // called when page is created before dom
  created() {
    this.getUnapprovedUsers();
    this.getUsers();
    this.getUnmatchedUsers();
    this.getDevices();
    this.getProjects();
    this.getOrphanDevices();
  },

  methods: {
    getUnapprovedUsers() {
      this.$http
        .get("admin/users/nonverified")
        .then((response) => {
          localStorage.setItem("token", response.headers.token);
          this.UnapprovedUsersList = response.data;
          this.unapproved_counter = response.data.length.toString();
        })
        .catch((error) => console.log(error));
    },

    getUsers() {
      this.$http
        .get("admin/users")
        .then((response) => {
          this.users_counter = response.data.length.toString();
        })
        .catch((error) => console.log(error));
    },

    getUnmatchedUsers() {
      this.$http
        .get("admin/users/childless")
        .then((response) => {
          this.unmatched_counter = response.data.length.toString();
        })
        .catch((error) => console.log(error));
    },

    getDevices() {
      this.$http
        .get("devices")
        .then((response) => {
          this.devices_counter = response.data.length.toString();
        })
        .catch((error) => console.log(error));
    },

    getProjects() {
      this.$http
        .get("projects")
        .then((response) => {
          this.projects_counter = response.data.projects.length.toString();
        })
        .catch((error) => console.log(error));
    },
    getOrphanDevices() {
      this.$http
        .get("devices/orphans")
        .then((response) => {
          this.orphans_counter = response.data.length.toString();
        })
        .catch((error) => console.log(error));
    },

    formatRoles(role_id, project) {
      if (role_id == 2) {
        return "Admin";
      } else {
        if (project !== null && project != "") {
          return "Project User";
        } else {
          return "Normal User";
        }
      }
    },

    isNumber(evt) {
      evt = evt || window.event;
      let charCode = evt.which || evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
      return false;
    },

    validateEmail(inputText) {
      var mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
      if (inputText.match(mailformat)) {
        return true;
      } else {
        return false;
      }
    },

    // APPROVE USER

    approveItem(item) {
      this.approvedIndex = this.UnapprovedUsersList.indexOf(item);
      this.approvedItem = Object.assign({}, item);
      this.dialogApprove = true;
    },

    approveItemConfirm() {
      let endpoint = `user/${this.approvedItem.id}/approve`;
      let method = "patch";
      let tableItem = this.approvedItem;
      this.$store
        .dispatch("approveUser", { endpoint, tableItem, method })
        .then((response) => {
          this.saveInline();
          this.getUsers();
          this.getUnapprovedUsers();
        })
        .catch((error) => {
          console.log(error);
          this.apiErrorInline();
        });

      this.closeApprove();
    },

    closeApprove() {
      this.dialogApprove = false;
      this.$nextTick(() => {
        this.approvedItem = Object.assign({}, this.defaultItem);
        this.approvedItem = -1;
      });
    },

    // DELETE USER

    deleteItem(item) {
      this.deletedIndex = this.UnapprovedUsersList.indexOf(item);
      this.deletedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      let endpoint = `user/${this.deletedItem.id}`;
      let method = "delete";
      let tableItem = this.deletedItem;
      this.$store
        .dispatch("deleteUser", { endpoint, tableItem, method })
        .then((response) => {
          this.UnapprovedUsersList.splice(this.deletedIndex, 1);
          this.saveInline();
          this.getUnapprovedUsers();
        })
        .catch((error) => {
          console.log(error);
          this.apiErrorInline();
        });

      this.closeDelete();
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.deletedItem = Object.assign({}, this.defaultItem);
        this.deletedItem = -1;
      });
    },

    // toasts/snackbar messages for actions
    saveInline() {
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Success!";
    },
    requiredInline() {
      this.snack = true;
      this.snackColor = "error";
      this.snackText = "Fill all required fields";
    },
    apiErrorInline() {
      this.snack = true;
      this.snackColor = "error";
      this.snackText = "Something went wrong";
    },
    cancelInline() {
      this.snack = true;
      this.snackColor = "error";
      this.snackText = "Canceled";
    },
    emailErrorInline() {
      this.snack = true;
      this.snackColor = "error";
      this.snackText = "Enter a valid Email";
    },
    reset() {
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Data reset to default";
    },
    openInline() {
      this.snack = true;
      this.snackColor = "info";
      this.snackText = "Dialog opened";
    },
    closeInline() {
      console.log("Dialog closed");
    },
  },
};
</script>

<style>
table.v-table thead tr {
  color: red !important;
}
tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}
.unapproved-users-table {
  max-height: 50vh;
  overflow-y: auto;
}

/* #table > .v-data-footer .v-icon {
  color: black;
} */
</style>
